import React, { FC, useEffect, useState } from 'react';
import { Box, Spinner } from '@chakra-ui/react';

import { useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';
import { unique } from '@app/utils';
import { SubChannel } from '@app/api';

import { useColumns } from './columns';
import EditVar from './edit';
import Error404 from '../../errors/404';

const SubChannelsTable: FC = () => {
  const api = useApi();
  const [channels, setChannels] = useState<EntityBase[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchChannels = async () => {
    setLoading(true);
    const { data } = await api.acb.getChannels({
      sort: '+id',
      offset: 0,
      limit: 1000,
      filter: {}
    });
    setChannels(unique<EntityBase & { channel?: string }>(data.data, 'channel')
      .map((channel: string, index) => ({
        id: index,
        name: channel,
      })));
    setLoading(false);
  };

  useEffect(() => {
    fetchChannels();
  }, []);
  
  const [fetchData] = useFetchData<SubChannel>({ method: api.acb.getChannels });

  const [editOpen, setEditOpen] = useState(false);
  const [operatedVar, setOperatedVar] = useState<SubChannel>();

  const columns = useColumns({
    channels,
    onEdit: (subChannel: SubChannel) => {
      setOperatedVar(subChannel);
      setEditOpen(true);
    }
  });

  const onClose = () => {
    fetchChannels();
    setEditOpen(false);
  };
  
  if (loading) {
    return <Box
      position="absolute"
      style={{ backgroundColor: 'rgba(255,255,255,0.6)' }}
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Spinner />
    </Box>;
  }

  return (
    <>
      <QueryTable<SubChannel>
        title="Каналы"
        columns={columns}
        onCreateClick={() => {
          setOperatedVar(undefined);
          setEditOpen(true);
        }}
        fetchData={fetchData}
      >
        <EditVar open={editOpen} channels={channels} setOpen={onClose} subChannel={operatedVar} />
      </QueryTable>
    </>
  );
};

export default SubChannelsTable;
